import { createTheme } from "@mui/material/styles";

//todo duplicated - figure out how to share this

declare module "@mui/material/styles" {
  interface Palette {
    elevation: {
      outlined: string;
    };
    costScore: {
      active: {
        low: string;
        medium: string;
        high: string;
      };
      inactive: string;
    };
    chartSeries: {
      baseline: string;
      businessGrowth: string;
      cleanerGrid: string;
      solutions: string;
      target: string;
      gap: string;
      remainingEmissions: string;
    };
  }

  interface PaletteOptions {
    elevation?: {
      outlined?: string;
    };
    costScore?: {
      active?: {
        low?: string;
        medium?: string;
        high?: string;
      };
      inactive?: string;
    };
    chartSeries?: {
      baseline?: string;
      businessGrowth?: string;
      cleanerGrid?: string;
      solutions?: string;
      target?: string;
      gap?: string;
      remainingEmissions?: string;
    };
  }
}

export const figTreeFontFamily = "'Figtree', 'Helvetica', 'Arial', sans-serif";

export const theme = createTheme({
  palette: {
    background: {
      default: "#f5f5f5",
    },
    primary: {
      main: "#007DC5",
      dark: "#0066A1",
      light: "#16AAFF",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#00ADEF",
      dark: "#0088BC",
      light: "#7CDBFF",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#D32F2F",
      dark: "#5f2120",
      light: "#FFEBEE",
      contrastText: "#FFFFFF",
    },
    warning: {
      contrastText: "#FFFFFF",
      main: "#EF6C00",
      dark: "#E65100",
    },
    info: {
      main: "#005d9f",
      dark: "#003172",
      light: "#007DB7",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#2F7220",
      dark: "#1E5811",
      light: "#56A345",
      contrastText: "#FFFFFF",
    },
    action: {
      disabled: "rgba(0, 0, 0, 0.38)",
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      hover: "rgba(0, 0, 0, 0.04)",
    },
    elevation: {
      outlined: "#e0e0e0",
    },
    costScore: {
      active: {
        low: "#2E7D32", // green for scores 1-2
        medium: "#EF6C00", // amber for score 3
        high: "#D32F2F", // red for scores 4-5
      },
      inactive: "#BDBDBD", // lighter grey
    },
    chartSeries: {
      baseline: "#0066A1", // primary.dark
      businessGrowth: "#0066A1", // primary.dark
      cleanerGrid: "#0066A1", // primary.dark
      target: "#69B958", // green/400
      solutions: "#16AAFF", // primary.light
      gap: "#FF9800", // orange/500
      remainingEmissions: "#CFD8DC", // blueGrey/100
    },
  },
  typography: {
    fontFamily: figTreeFontFamily,
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingLeft: 0,
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
          boxShadow: "none",
          border: "1px solid #E0E0E0",
          "&:before": {
            opacity: 0,
          },
          "&:hover,&:focus": {
            backgroundColor: "#ECEFF1",
          },
        },
      },
    },
  },
});
